export default __webpack_public_path__ + "static/media/grayMarker.169826b3.svg";